import { requiredString } from 'src/utils/schemas';
import * as Yup from 'yup';
import { companyStatus } from '../../constants';

export const updateCompanyValidationSchema = Yup.object().shape({
	tradingName: requiredString,
	status: requiredString.oneOf(Object.values(companyStatus)),
});
